import { render, staticRenderFns } from "./assignmentList.html?vue&type=template&id=76c503f0&scoped=true&"
import script from "./assignmentList.js?vue&type=script&lang=js&"
export * from "./assignmentList.js?vue&type=script&lang=js&"
import style0 from "./assignmentList.css?vue&type=style&index=0&id=76c503f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c503f0",
  null
  
)

export default component.exports